<template>
  <!-- 这里是一个维护升级页面 -->
  <div class="constructing">
    <div class="bg">
      <img class="bgImg" src="@/assets/maintenance.jpg" />
      <div class="title">
        <div>感谢您的访问，网站正在改版升级，以便在线提供法律服务。谢谢!</div>
        <div>如有疑问或咨询请拨打电话:010-64612505，15711192203</div>
      </div>

    </div>
  </div>
</template>



<style lang="less" scoped>
.constructing {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  font-size: 16px;
  font-family: sans-serif;

  .bg {
    max-width: 1080px;
    width: 80%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .bgImg {
      width: 100%;
    }

    @media screen and (max-width: 600px) {
      width: 100%;
    }
  }

  .title {
    position: absolute;
    left: 30%;
    font-size: 0.16rem;
    top: 66%;
    @media screen and (max-width: 600px) {
      top: 60%;
    }
  }
}
</style>